export interface SiteLink {
  name: string;
  path: string;
  summary?: string;
  children?: SiteLink[];
}

export const landscapingChildren: SiteLink[] = [
  { name: "Landscape Renovation", path: "/landscape-renovation", summary: "Clear overgrowth, rebuild tired beds, and transform a property using the existing landscape renovation program." },
  { name: "Gardens & Planting", path: "/garden-and-planting", summary: "Create garden beds, select plants, and prepare soil for plantings suited to the property." },
  { name: "Stonework & Hardscaping", path: "/stonework", summary: "Add retaining walls, pathways, and stone edging that define and support the landscape." },
];

export const residentialServiceLinks: SiteLink[] = [
  { name: "Landscape Maintenance", path: "/" },
  { name: "Lawn Care", path: "/lawn-care" },
  { name: "Landscaping", path: "/landscaping", children: landscapingChildren },
  { name: "Tree & Shrub Care", path: "/tree-and-shrub-care" },
  { name: "Snow Plowing", path: "/snow-plowing" },
];

export const commercialServiceLink: SiteLink = {
  name: "Commercial",
  path: "/commercial-services",
};

export const allServiceLinks: SiteLink[] = [
  ...residentialServiceLinks,
  { name: "Commercial Landscaping", path: "/commercial-services" },
];

export const homepageServiceLinks: SiteLink[] = [
  { name: "Lawn Care", path: "/lawn-care", summary: "Mowing, trimming, edging, turf care, and seasonal cleanup for residential and commercial lawns." },
  { name: "Landscaping", path: "/landscaping", summary: "Landscape renovation, gardens and planting, and hardscaping coordinated for the whole property." },
  { name: "Tree & Shrub Care", path: "/tree-and-shrub-care", summary: "Pruning, shaping, and planting that supports healthy trees and ornamental shrubs." },
  { name: "Snow Plowing", path: "/snow-plowing", summary: "Snow removal and ice management for homes, businesses, and shared properties." },
  { name: "Commercial Landscaping", path: "/commercial-services", summary: "Scheduled grounds care, installations, and seasonal property services for commercial sites." },
];

export const townServiceLinks: SiteLink[] = [
  { name: "Landscape Maintenance", path: "/", summary: "Seasonal property care keeps lawns, planting beds, shrubs, and surrounding grounds orderly throughout the year." },
  { name: "Lawn Care", path: "/lawn-care", summary: "Mowing, trimming, edging, and turf care provide clean lines and healthy grass through the growing season." },
  { name: "Landscaping", path: "/landscaping", summary: "Landscape renovation, garden planting, and stonework coordinate larger changes around the property." },
  { name: "Tree & Shrub Care", path: "/tree-and-shrub-care", summary: "Pruning, shaping, and tree selection protect mature plantings and give growing landscapes more structure." },
  { name: "Snow Plowing", path: "/snow-plowing", summary: "Snow plowing and ice management help homes, businesses, and shared properties stay accessible in winter." },
  { name: "Commercial Landscaping", path: "/commercial-services", summary: "Scheduled grounds care supports clean entrances, maintained common areas, and dependable service for commercial properties." },
];

export const serviceAreaLinks: SiteLink[] = [
  { name: "Franklin", path: "/service-areas/franklin" },
  { name: "Bellingham", path: "/service-areas/bellingham" },
  { name: "Medway", path: "/service-areas/medway" },
  { name: "Norfolk", path: "/service-areas/norfolk" },
  { name: "Wrentham", path: "/service-areas/wrentham" },
];

const servicePaths = [
  "/",
  "/lawn-care",
  "/landscaping",
  "/garden-and-planting",
  "/landscape-renovation",
  "/stonework",
  "/tree-and-shrub-care",
  "/snow-plowing",
  "/commercial-services",
  "/commercial-services/skid-steer-services",
];

export const relatedServicesByPath: Record<string, SiteLink[]> =
  Object.fromEntries(
    servicePaths.map((path) => [
      path,
      allServiceLinks.filter((link) => link.path !== path).slice(0, 5),
    ]),
  );

export const neighboringAreasByPath: Record<string, SiteLink[]> =
  Object.fromEntries(
    serviceAreaLinks.map((area) => [
      area.path,
      serviceAreaLinks.filter((candidate) => candidate.path !== area.path),
    ]),
  );

export const routeLabels: Record<string, string> = {
  ...Object.fromEntries(allServiceLinks.map(({ name, path }) => [path, name])),
  ...Object.fromEntries(landscapingChildren.map(({ name, path }) => [path, name])),
  ...Object.fromEntries(serviceAreaLinks.map(({ name, path }) => [path, name])),
  "/commercial-services/skid-steer-services": "Skid Steer Land Clearing",
  "/gallery": "Gallery",
  "/contact": "Contact",
  "/privacy": "Privacy Policy",
};